export enum TokenType {
    COIN,
    UNI_PAIR,
}
